import { useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import moment from "moment";
// Constants - Functions
import { WEB_SERVICE_MIMS } from "../../../../../../config/constants";
// Components
import { MainDiv, NotesTitle, NotesDiv, NoteDate, Textarea, ActionsDiv, CancelButton, NewNoteButton } from "./styles";
import UseFetch from "../../../../../../config/useFetch";

const AddNote = ({ setShowNewNote, refreshData, setRefreshData }) => {
  const [newNote, setNewNote] = useState("");
  const [newNoteError, setNewNoteError] = useState(false);

  const { patientId } = useParams();

  const handleSetNote = (e) => {
    setNewNote(e.target.value);
    setNewNoteError(false);
  };

  const addNewNote = () => {
    if (!newNote) {
      setNewNoteError(true);
      return toast.error("You must write a note");
    }

    UseFetch("post", `${WEB_SERVICE_MIMS}/recsys/add-note/${patientId}`, new AbortController(), {
      note: newNote,
    })
      .then(({ data }) => {
        if (data.noteAdded) {
          toast.success("Note saved successfully");
          setShowNewNote(false);
          setRefreshData(!refreshData);
        }
      })
      .catch((error) => {
        console.log("Save note: ", error);
      });
  };

  return (
    <MainDiv>
      <NotesTitle>Add note</NotesTitle>
      <NotesDiv>
        <NoteDate>{moment().format("DD-MM-YYYY")}</NoteDate>
        <Textarea id="noteText" value={newNote} onChange={handleSetNote} placeholder="Write your note here" error={newNoteError} />
      </NotesDiv>
      <ActionsDiv>
        <CancelButton onClick={() => setShowNewNote(false)}>Cancel</CancelButton>
        <NewNoteButton onClick={addNewNote}>Save</NewNoteButton>
      </ActionsDiv>
    </MainDiv>
  );
};

export default AddNote;
